<template>
  <div class="row mt-2">
    <div class="col">
      <span>For ADAS Map, this location has</span>
      <span class="ms-2 custom-name">{{ optSearch }}</span>
      <span class="ms-2">of being searched by a Provider.</span>
    </div>
  </div>
  <div v-if="isDefaultProvider" class="row mt-4">
    <div class="col">
      <span>As default (Mobile Copilot), this location is being served by:</span>
      <span class="ms-2 custom-name">{{ firmName }}</span>
      <span class="ms-2">id: {{ id }}</span>
    </div>
  </div>
  <div v-if="anyProviders" class="row mt-4">
    <div class="col">
      <span>Provider Membership with:</span>
    </div>
  </div>
  <div v-if="anyProviders" class="row mt-1">
    <div class="col-6">
      <ul class="list-group list-group-flush">
        <li v-for="(member, index) in servedMembers" :key="index" class="list-group-item">
          <span class="custom-name">{{ member.firmName }}</span>
          <span class="ms-2">id: {{ member.firm2 }}</span>
          <span class="custom-mcp">{{ member.isMCP ? 'Mobile Copilot' : null }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from 'pinia'
import { locationStore } from '@/stores/location'
export default {
  name: 'LocationServedBy',
  computed: {
    ...mapState(locationStore, ['servedBy', 'location', 'servedMembers']),
    firmName() {
      let _data = null
      if (this.servedBy) {
        _data = this.servedBy.firmName
      }
      return _data
    },
    id() {
      let _data = null
      if (this.servedBy) {
        _data = this.servedBy.firm
      }
      return _data
    },
    optSearch() {
      let _data = 'opted in'
      if (this.location) {
        if (this.location.isExcludeFromSearch) {
          _data = 'opted out'
        }
      }
      return _data
    },
    isDefaultProvider() {
      let _is = false
      if (this.servedBy) {
        if (this.servedBy.firmName !== null) {
          _is = true
        }
      }
      return _is
    },
    anyProviders() {
      let _any = false
      if (this.servedMembers) {
        if (this.servedMembers.length > 0) {
          _any = true
        }
      }
      return _any
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-name {
  font-size: 1em;
  font-weight: 500;
}
.custom-mcp {
  font-size: 0.8em;
  font-style: italic;
  color: #007bff;
  position: absolute;
  right: 0;
}
</style>
